import { Link, Outlet, useSearchParams } from "react-router";
import { Box, Tabs, Tab, useTheme, useMediaQuery } from '@mui/material'
import { getViewPath, type ViewTab, useViewRoute } from '../viewRoute';

export function TabsLayout() {
    const [searchParams] = useSearchParams()
    const { tab, mainId, sideItemId, treeName } = useViewRoute()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px [web:1]
    const preservedSearchParams = new URLSearchParams(searchParams)
    preservedSearchParams.delete('main')
    preservedSearchParams.delete('sideItem')
    const search = preservedSearchParams.toString()
    const tabUrl = (tab: ViewTab) => `${getViewPath(tab, mainId, sideItemId, treeName)}${search ? `?${search}` : ''}`

    const currentTabValue = tab ? getViewPath(tab, mainId, sideItemId, treeName) : false;

    return (
        <Box sx={{ maxWidth: isMobile ? "100vw" : "inherit", width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <Box sx={{ flexShrink: 0, borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={currentTabValue}
                    aria-label="Genealogy explorer"
                    variant={"scrollable"}
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{ width: '100%', overflowX: isMobile ? 'auto' : 'visible' }}
                >
                    <Tab label="Éventail" component={Link} to={tabUrl('ascendency')} value={getViewPath('ascendency', mainId, sideItemId, treeName)} />
                    <Tab label="Géographie" component={Link} to={tabUrl('maps')} value={getViewPath('maps', mainId, sideItemId, treeName)} />
                    <Tab label="Professions" component={Link} to={tabUrl('occupations')} value={getViewPath('occupations', mainId, sideItemId, treeName)} />
                    <Tab label="Événements notables" component={Link} to={tabUrl('notableevents')} value={getViewPath('notableevents', mainId, sideItemId, treeName)} />
                </Tabs>
            </Box>
            <Box role="tabpanel" sx={{ paddingTop: 1, flex: 1, minHeight: 0, overflowY: 'auto' }}>
                <Outlet />
            </Box>
        </Box>
    )
}
